import {
  ChargeCardEligibilityResult,
  ChargeCardEligibilityResultTypenames,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import getChargeCardEligibility from 'services/graphql/queries/Believe/GetChargeCardEligibility';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

export interface IChargeCardEligibilityType {
  chargeCardEligibility: ChargeCardEligibilityResult;
}

const useGetChargeCardEligibility = () => {
  const router = useRouter();
  const [{ data, fetching, error }] = useQuery<IChargeCardEligibilityType>({
    query: getChargeCardEligibility,
    requestPolicy: 'network-only',
  });
  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  const cancel = () => {
    router.back();
  };

  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const chargeCardEligibilityError =
    data?.chargeCardEligibility?.__typename ===
    ChargeCardEligibilityResultTypenames?.ChargeCardEligibilityError;

  const errorModel =
    error?.message || chargeCardEligibilityError
      ? {
          screenType: ErrorScreenType.Error,
          messageHeadline: defaultTitle,
          messageBody: error?.message ?? defaultMessage,
          ...buttons,
        }
      : null;

  return {
    chargeCardEligibilityData: data?.chargeCardEligibility,
    errorModel: errorModel,
    loading: fetching,
  };
};

export default useGetChargeCardEligibility;
